import { FormattedMessage } from 'react-intl';

import { OfferingId } from '@arrived/models';
import { MAX_STALE_TIME, useOfferingQuery } from '@arrived/queries';

import { LeaseStatusMessageWithTooltip } from '../../tooltips';

export interface LeaseStatusMessageProps {
  offeringId: OfferingId;
}

export const OfferingLeaseStatusMessage = ({ offeringId }: LeaseStatusMessageProps) => {
  const offeringState = useOfferingQuery(offeringId, { staleTime: MAX_STALE_TIME });

  switch (offeringState.status) {
    case 'loading':
      return <FormattedMessage id="loading" defaultMessage="Loading..." />;
    case 'error':
      return <>-</>;
    case 'success':
      return <LeaseStatusMessageWithTooltip leaseStatus={offeringState.data.properties[0]?.leaseStatus} />;
  }
};
